/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/styles";
import { Checkbox, Divider, FormControlLabel, Snackbar } from "@material-ui/core";
import { ReflexContainer, ReflexElement, ReflexSplitter } from "react-reflex";
import { Alert } from "@material-ui/lab";

import uiConf from "../../config/uiConf";

import apiClient from "../../lib/common/apiClient";
import checkValidation from "../../lib/utils/checkValidation";
import checkConditionWithMsg from "../../lib/utils/checkConditionWithMsg";

import Dialog from "../dialog/functional/Dialog";
import DialogHeader from "../dialog/functional/DialogHeader";
import DialogContent from "../dialog/functional/DialogContent";
import DialogTitle from "../dialog/functional/DialogTitle";
import DialogActionsOkCancel from "../dialog/functional/DialogActionsOkCancel";

import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

import AutoForm from "../form/functional/AutoForm";

import getSchema from "../../lib/api/getSchema";
import defineConf from "../../config/defineConf";

const useStyles = makeStyles((theme) => ({
    keepOpenSwitch: {
        marginLeft: "8px",
    },

    label: {
        fontSize: "smaller",
        color: theme.palette.primary.text,
    },
}));

function TkCustomerSupplyInputInspectionCreateDialog(props) {
    const classes = useStyles();

    const {
        id,
        mode,
        schema,
        refresh,

        title,
        formId,

        moveable,
        resizable,
        fullWidth,

        onInitialized,
        onSuccess,
        onClose,

        onDialogUpdateDetail,

        appendCheckBox,

        ...others
    } = props;

    const [keepOpen, setKeepOpen] = useState(false);
    const [shipmentAll, setShipmentAll] = useState(false);
    const [disabled, setDisabled] = useState(true);
    const [formData, setFormData] = useState({});
    const [instance, setInstance] = useState();
    const [grid, setGrid] = useState();
    const [height, setHeight] = useState(0);
    const [api, setApi] = useState();

    const [onSelectMst, setOnSelectMst] = useState();

    const [notification, setNotification] = useState({
        open: false,
        severity: "success",
        msg: "",
    });

    const [isEmpty, setIsEmpty] = useState(false);

    const onLoadData = (data) => {

        setIsEmpty(data.length < 1 ? true : false);
    };

    const handleResize = () => {
        setHeight(document.documentElement.offsetHeight - 96);
    };

    useEffect(() => {
        window.addEventListener("resize", handleResize);

        handleResize();

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        (async () => {
            if (grid) {
                grid.selectionChanged.addHandler((grid, event) => {
                    if (grid.selectedItems && grid.selectedItems[0]) {
                        setOnSelectMst(grid.selectedItems[0]);
                    } else {
                        setOnSelectMst({})
                    }
                });

                grid.itemsSourceChanged.addHandler((grid, event) => {
                    if (grid.selectedItems && grid.selectedItems[0]) {
                        setOnSelectMst(grid.selectedItems[0]);
                    } else {
                        setOnSelectMst({})
                    }
                });
            }
        })();
    }, [grid]);

    useEffect(() => {
        if (onSelectMst?.orderBuyerDetailId && onSelectMst?.orderBuyerId) {
            setFormData((formData) => {
                let newFormData = {
                    ...formData,
                    customerSupplyInputInspectionId: "inputInspectionContainerNo",
                    orderBuyerId: onSelectMst?.orderBuyerId,
                    orderBuyerDetailId: onSelectMst?.orderBuyerDetailId,
                    inspectionDate: new Date(),
                    inputDate: new Date(),
                    qcResult: defineConf.qcResult.QC_OK,
                    defectiveCode:
                        !formData?.qcResult || formData?.qcResult === defineConf.qcResult.QC_OK
                            ? "INS000"
                            : formData?.defectiveCode,
                    ...onSelectMst,
                };

                return newFormData;
            });
        }
    }, [onSelectMst?.orderBuyerDetailId]);

    const { t } = useTranslation();

    const onCloseDialog = () => {
        setDisabled(true);

        setFormData((formData) => {

            let newFormData = {
                ...formData,
                defectiveCode: undefined,
                inputManager: undefined,
                inspector: undefined,
                description: undefined,
                wareHouseCode: undefined,
                inputDate: undefined,
            };
            return newFormData;
        });

        if (onClose) {
            onClose();
        }
    };

    const onCancel = () => {
        setFormData((formData) => {
            let newFormData = {
                ...formData,
                defectiveCode: undefined,
                inputManager: undefined,
                inspector: undefined,
                description: undefined,
                wareHouseCode: undefined,
                inputDate: undefined,
            };
            return newFormData;
        });

        setDisabled(true);

        instance.hide();
    };

    const onDialogInitialized = (instance) => {
        setInstance(instance);

        if (onInitialized) {
            onInitialized(instance);
        }
    };

    const onGridInitialized = (grid) => {
        grid.selectionMode = "Row";

        setGrid(grid);
    };

    const onApiInitialized = (api) => {
        setApi(api);
    };

    const onChange = (formData) => {
        setFormData(formData);

        setDisabled(false);
    };

    const notifySuccess = (msg) => {
        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });
    };

    const refreshed = (msg) => {
        notifySuccess(msg);

        if (api) {
            api.refresh();
        }

        if (refresh) {
            refresh.refresh();
        }
    };

    const notifyFailure = (msg) => {
        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });
    };

    const nofifyWarning = (msg) => {
        console.warn(msg);

        setNotification({
            severity: "warning",
            msg: msg,
            open: true,
        });
    };

    const onApiSuccess = (result) => {
        refreshed();

        if (onSuccess) {
            setTimeout(onSuccess(result.data), 0);
        }
        if (!keepOpen) {
            instance.hide();
        }
    };

    const onApiFailure = (reason) => {
        notifyFailure(
            t("error.insertFailure", {
                reason: reason.response ? reason.response.data : JSON.stringify(reason),
            })
        );
    };

    const checkItemValidation = (schema, formData) => {
        for (const column of schema.columns) {
            let [valid, msg] = checkValidation("create", column, column.validation, formData[column.name] || "");

            if (!valid) {
                nofifyWarning(msg);
                return false;
            }
        }

        return true;
    };

    const onOk = (schema, formData) => {
        if (formData.qcResult === defineConf.qcResult.QC_OK) {
            formData.defectiveCode = "INS000";
        }

        if (!checkItemValidation(schema, formData)) {
            console.error(" From Validation Failed ");

            return;
        }

        if (schema.validation) {
            let [valid, msg] = checkConditionWithMsg(formData, schema.validation);

            if (!valid) {
                nofifyWarning(t("warning.formDataValidationFail", { msg: msg }));
                return;
            }
        }

        let url = `/api/TkCustomerSupplyInputInspection`;

        let apiData = { ...formData };

        let form = new FormData();

        let json = {};
        let deleted = {};

        for (const formItem in apiData) {
            if (apiData[formItem] !== undefined) {
                json[formItem] = apiData[formItem];
            }
        }

        form.append("deleted", JSON.stringify(deleted));
        form.append("json", JSON.stringify(json));

        apiClient
            .post(url, form, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((result) => onApiSuccess(result))
            .catch((reason) => onApiFailure(reason));

    };

    const onCloseNotification = () => {
        setNotification((notification) => {
            return { ...notification, open: false };
        });
    };

    const checkKeepOpen = () => {
        return (
            <>
                <FormControlLabel
                    control={
                        <Checkbox
                            className={classes.keepOpenSwitch}
                            checked={keepOpen}
                            color="primary"
                            onChange={() => setKeepOpen((keepOpen) => !keepOpen)}
                            name="checkKeepOpen"
                            size="small"
                        />
                    }
                    label={<span className={classes.label}>{t("term.keepDialogOpen")}</span>}
                />

                {appendCheckBox ? (
                    <FormControlLabel
                        control={
                            <Checkbox
                                className={classes.keepOpenSwitch}
                                checked={shipmentAll}
                                color="primary"
                                onChange={() => setShipmentAll((shipmentAll) => !shipmentAll)}
                                name="checkKeepOpen"
                                size="small"
                            />
                        }
                        label={<span className={classes.label}>{t("term.shipmentAll")}</span>}
                    />
                ) : (
                    <></>
                )}
                <div style={{ flexGrow: 1 }}></div>
            </>
        );
    };

    return (
        <>
            <Dialog
                id={id}
                moveable={moveable ? moveable : uiConf.dialogMoveable}
                resizable={resizable ? resizable : uiConf.dialogResizable}
                fullWidth={fullWidth ? fullWidth : uiConf.dialogFullWidth}
                maxWidth="lg"
                onClose={onCloseDialog}
                onInitialized={onDialogInitialized}
                {...others}
            >
                <DialogHeader>
                    <DialogTitle>{title}</DialogTitle>
                </DialogHeader>

                <Divider />

                <DialogContent style={{ height: height }}>
                    <ReflexContainer orientation="vertical">
                        <ReflexElement>
                            <BasicCrudScreenType
                                id={formId}
                                embededInOtherScreenType
                                headerTitle={t("term.soDetail")}
                                table="MomSysZvwOrderBuyerDetailNotInput"
                                view="MomSysZvwOrderBuyerDetailNotInput"
                                noCreate
                                noEdit
                                noDelete
                                noExcel
                                noOutputSize
                                noFilter
                                onApiInitialized={onApiInitialized}
                                onInitialized={onGridInitialized}
                                onLoadData={onLoadData}
                            />
                        </ReflexElement>
                        <ReflexSplitter />
                        <ReflexElement>
                            <div
                                style={{
                                    padding: "32px",
                                }}
                            >
                                <AutoForm
                                    id="TkVwCustomerSupplyInputInspection"
                                    schema={schema}
                                    mode="edit"
                                    initialData={formData}
                                    onChange={onChange}
                                />
                            </div>
                        </ReflexElement>
                    </ReflexContainer>

                    <Snackbar
                        open={notification.open && notification.severity !== "success"}
                        autoHideDuration={uiConf.dialogNotifyAutoHideDuration}
                        onClose={onCloseNotification}
                    >
                        <Alert onClose={onCloseNotification} variant="filled" severity={notification.severity}>
                            {notification.msg}
                        </Alert>
                    </Snackbar>
                </DialogContent>

                <Divider />

                <DialogActionsOkCancel
                    firstActionComponent={checkKeepOpen}
                    labels={[t("buttonName.input")]}
                    buttonDisabled={[(disabled || isEmpty), false]}
                    onOk={() => onOk(schema, formData)}
                    onCancel={onCancel}
                ></DialogActionsOkCancel>
            </Dialog>
        </>
    );
}

export default TkCustomerSupplyInputInspectionCreateDialog;
